import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useSupabaseAuth } from '@/lib/hooks'
import { AuthCheckScreen } from '@/components/auth/AuthCheckScreen'

interface AuthGuardProps {
  children: React.ReactNode
}

export function AuthGuard({ children }: AuthGuardProps): React.JSX.Element {
  const { user, isLoading, isAuthCheckSlow, authError, retryAuthCheck } = useSupabaseAuth()
  const location = useLocation()

  if (authError && !user) {
    return <AuthCheckScreen error={authError} onRetry={retryAuthCheck} />
  }

  if (isLoading) {
    return <AuthCheckScreen isSlow={isAuthCheckSlow} />
  }

  if (!user) {
    const redirect = `${location.pathname}${location.search}`
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirect)}`} replace />
  }

  return <>{children}</>
}
